import {getComponent} from "../jsbase/utils";

export default {
    args: 'targetEl',
    templateId: null,
    $pricesEl: null,
    $treeTableEl: null,
    $searchInputEl: null,
    $searchResltusEl: null,

    props: {
        templateId: Number,
        $pricesEl: String,
        $treeTableEl: String,
    },

    connect() {
        this.$pricesEl = $(document.querySelector('.bkdb-slidein-prices'));
        this.$treeTableEl = $(this.el).find('table');
        var me = this;

        this.$searchInputEl = $(this.el).find('[name="Query"]');
        this.$searchInputEl.on('keyup change', this.search);
        this.$searchResultsEl = $(this.el).find('.search-results');

        $('.slidein-footer').css({ maxHeight: '40vh', overflow: 'auto' });

        this.$treeTableEl.treetable({
            expandable: true,
            clickableNodeNames: true,
            columnElType: 'td',
            column: 0,
            indent: 15,
            expanderTemplate: '<a class="linkify loader-indicator" href="#"><i class="fa bi-plus"></i><i class="fa bi-dash"></i><i class="fa bi-arrow-repeat fa-spin"></a>',
            onNodeCollapse: function () {
                var node = this;
                me.$treeTableEl.treetable("unloadBranch", node);
            },
            onNodeExpand: function() {
                var node = this;
                node.row.addClass('expanding');
                var parentId = node.row.attr('data-tt-id');
                connection.getHtmlPart('/Preise/PositionTree', {
                    data: {
                        parentId: parentId,
                    },
                    onSuccess: (response) => {
                        node.row.removeClass('expanding');
                        me.$treeTableEl.treetable("loadBranch", node, response);
                        me.updateEvents(me.$treeTableEl.find('[data-tt-parent-id="'+ parentId +'"]'));
                    }
                });
            }
        });
        this.updateEvents(this.$treeTableEl.find('tr'));
    },

    methods: {
        updateEvents(rows) {
            rows.find('[data-show-prices]').click((ev) => {
                var id = $(ev.currentTarget).attr('data-show-prices');
                this.renderPrices(id);
            });
        },

        renderPrices(id) {
            this.$pricesEl.empty();
            connection.getJson('/Project/PositionPriceDetail/' + id, {
                onSuccess: (response) => {
                    var tbl = $('<table class="table items"></table>');
                    var $th = $('<tr></tr>');
                    $th.append(`<th>Beschreibung</th>`);
                    $th.append(`<th style="width:80px;" class="text-right" colspan="2">Preis</th>`);
                    $th.append(`<th style="width:80px;" class="text-right" colspan="2">Anzahl</th>`);
                    $th.append(`<th style="width:40px;" class="text-right">Total</th>`);
                    tbl.append($th);

                    var total = 0;
                    $.each(response.Prices, (i, item) => {
                        var price = parseFloat(item.joins.PositionPriceLng.Price || item.Price);
                        total += price * item.Amount;
                        var $tr = $('<tr></tr>');
                        $tr.append(`<td><div class="input readonly">${item.Description}</div></td>`);
                        $tr.append(`<td class="border-left"><div class="input readonly text-right" data-price="${price}">${price.toFixed(2)}</div></td>`);
                        $tr.append(`<td><div class="input readonly text-right">${item.PriceUnit}</div></td>`);
                        $tr.append(`<td class="border-left"><div contenteditable data-amount class="input text-right">${item.Amount}</div></td>`);
                        $tr.append(`<td><div class="input readonly text-right">${item.AmountUnit}</div></td>`);
                        $tr.append(`<td class="border-left"><div class="input readonly text-right" data-line-total="${(price * item.Amount)}">${(price * item.Amount).toFixed(2)}</div></td>`);
                        tbl.append($tr);

                        $tr.find('[data-amount]').blur((ev) => {
                            var me = $(ev.currentTarget);
                            var tr = me.closest('tr');
                            var lineTotal = parseFloat(me.text()) * tr.find('[data-price]').attr('data-price');
                            tr.find('[data-line-total]')
                                .attr('data-line-total', lineTotal)
                                .text(lineTotal.toFixed(2));

                            var $footerTotal = this.$pricesEl.find('.footer [data-total]');
                            var total = this.$pricesEl.find(`[data-line-total]`).sum('data-line-total');
                            $footerTotal.attr('data-total', total)
                                .html(total.toFixed(2));
                        });
                    });

                    var $tf = $('<tr class="footer"></tr>');
                    $tf.append(`<th>Total</th>`);
                    $tf.append(`<th colspan="3"></th>`);
                    $tf.append(`<th colspan="2" class="text-right" data-total>${total.toFixed(2)}</th>`);
                    tbl.append($tf);

                    this.$pricesEl.append(`<h4>${response.Position.ArchiNumber} ${response.Position.Name}</h4>`);
                    this.$pricesEl.append(tbl);
                },
            });
        },

        search() {
            var query = this.$searchInputEl.val();
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            if (query.trim() === '') {
                this.$searchResultsEl.addClass('d-none');
                this.$treeTableEl.removeClass('d-none');
                return;
            }
            //
            this.searchTimeout = setTimeout(() => {
                this.searchTimeout = null;
                connection.getJson('/Project/SearchPositions', {
                    data: {
                        search: this.$searchInputEl.val(),
                        templateId: this.templateId,
                        onlyLeafs: true,
                        type: 'bkdb',
                    },
                    onSuccess: (response) => {
                        this.$searchResultsEl.empty();
                        this.$searchInputEl.parent().find('.input-group-append .input-group-text').html('Total: ' + response.totalEntries);
                        $.each(response.data, (i, item) => {
                            var id = item.value.split(',').slice(-1)[0];
                            var $el = $(`<div class="list-group-item" data-id="${id}">${item.label}</div>`);
                            this.$searchResultsEl.append($el);
                            $el.click(() => {
                                this.renderPrices(id);
                            });
                        });
                        this.$searchResultsEl.removeClass('d-none');
                        this.$treeTableEl.addClass('d-none');
                    },
                });
            }, 300);
        },
    },

}
